import { render, staticRenderFns } from "./require-table.vue?vue&type=template&id=4fcdb14e&scoped=true&"
import script from "./require-table.vue?vue&type=script&lang=js&"
export * from "./require-table.vue?vue&type=script&lang=js&"
import style0 from "./require-table.vue?vue&type=style&index=0&id=4fcdb14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdb14e",
  null
  
)

export default component.exports